import { CalendlyExpert } from "../../experts/types/CalendlyExpert";
import { ExpertRole } from "../../experts/types/ExpertRole";

export const handleExpertRole = (expert: CalendlyExpert) => {
    switch (expert.role) {
      case ExpertRole.Nutritionist:
        return 'Nutrizionista';
      case ExpertRole.Specialist:
      case ExpertRole.Physician:
        return 'Medico endocrinologo';
    }
  };